import localDB from "./localDB";

let GLOBAL = require('./globals');

const WarehouseStockControlData = {
    async add(data, res) {
        await fetch(`${GLOBAL.BASE_URL}warehouse-stock-control`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}warehouse-stock-control/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async move(data, res) {
        await fetch(`${GLOBAL.BASE_URL}warehouse-stock-control-move`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
};

export default WarehouseStockControlData;


// WEBPACK FOOTER //
// ./src/data/WarehouseStockControlData.js